import React, { useState } from "react"
import Container from './Container'
import TrailInner from './TrailInner'
import Intersection from './Intersection'

const Content = ({ children, target }) => {
  
  const [isVisible, setIsVisible] = useState(false);
  return (
    <Intersection setIsVisible={setIsVisible} ref={target.ref}>
      <Container>
        <TrailInner isVisible={isVisible}>
          {children}
        </TrailInner>
      </Container>
    </Intersection>
  )
}

export default Content